// Added by Sejune Oh on 2020-03-17
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/***
 *  [WebComponents]
 * -  TaskList
 * -  TaskDetailView
 * -  TaskMonitoring
 * -  LCSStatistic
 * -  WPSMonitoring
 */

// Register function
import registerWebComponent from '@/helper/registerWebComponent'

// Components
import { TaskListWrapper, TaskListStyles } from './TaskListWrapper'
import { TaskDetailViewWrapper, TaskDetailStyles } from './TaskDetailViewWrapper'
import { TaskMonitoringBoxWrapper, TaskMonitoringBoxStyles } from './TaskMonitoringBoxWrapper'
import { LCSStatisticWrapper, LCSStatisticStyles } from './LCSStatisticWrapper'
import { WPSMonitoringBoxWrapper, WPSMonitoringBoxStyles } from './WPSMonitoringBoxWrapper'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// [1] TaskList
registerWebComponent({
  defaultKey: 'dbtasklist',
  Component: TaskListWrapper,
  customElementName: 'actuator-db-task-list',
  styles: TaskListStyles
})

// [2] TaskDetailView
registerWebComponent({
  defaultKey: 'dbtaskdetail',
  Component: TaskDetailViewWrapper,
  customElementName: 'actuator-db-task-detail',
  styles: TaskDetailStyles,
})

// [3] TaskMonitoring
registerWebComponent({
  defaultKey: 'dbtaskmonitoring',
  Component: TaskMonitoringBoxWrapper,
  customElementName: 'actuator-db-task-monitoring',
  styles: TaskMonitoringBoxStyles,
})

// [4] LCS Statistics
registerWebComponent({
  defaultKey: 'statistics',
  Component: LCSStatisticWrapper,
  customElementName: 'actuator-statistics',
  styles: LCSStatisticStyles,
})

// [5] WPSMonitoring
registerWebComponent({
  defaultKey: 'dbwpsmonitoring',
  Component: WPSMonitoringBoxWrapper,
  customElementName: 'actuator-wps-monitoring',
  styles: WPSMonitoringBoxStyles,
})
